// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/RelatoriosOS_ConsumoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Resposta de /relatorios/relatorios_os/consumo (chamado NS 2026-0104).
 *
 * Lista já filtrada pelo filtro global (franquias + período). O resumo
 * (clientes recorrentes) é calculado no front.
 */
import type { RelatoriosOS_ConsumoRow } from './RelatoriosOS_ConsumoRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type RelatoriosOS_ConsumoResponseDados = RelatoriosOS_ConsumoRow[];

export type RelatoriosOS_ConsumoResponse = ApiResponse<RelatoriosOS_ConsumoResponseDados>;

registerResponseContract('RelatoriosOS_ConsumoResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      franquia_id:          { type: 'number',  required: true },
      franquia_nome:        { type: 'string',  required: true },
      cliente_id:           { type: 'number',  required: true },
      cliente_nome:         { type: 'string',  required: true },
      cliente_telefone:     { type: 'string',  required: true },
      ordens:               { type: 'number',  required: true },
      servicos:             { type: 'number',  required: true },
      pares:                { type: 'number',  required: true },
      valor:                { type: 'number',  required: true },
      ticket_medio:         { type: 'number',  required: true },
      valor_por_par:        { type: 'number',  required: false },
      primeira_data:        { type: 'string',  required: true },
      ultima_data:          { type: 'string',  required: true },
      intervalo_medio_dias: { type: 'number',  required: false },
      dias_desde_ultimo:    { type: 'number',  required: true },
      faixa_recorrencia:    { type: 'string',  required: true },
    },
  },
})
